<template>
    <div id="vendors-items-container">
        <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate">{{ $t('programSetupListing.Title') }}</h4>
                <div class="row">
                    <div class="col-sm-12 col-md-3" v-if="hasPermissionAdd()">
                        <MdButton
                            v-bind:Label="$t('Shared.Add')"
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="addProgram"
                            v-bind:Name="'btn_add_vendor'"
                        >
                        </MdButton>
                    </div>

                    <div
                        v-bind:class="
                            hasPermissionAdd()
                                ? 'col-sm-12 col-md-9 mb-4'
                                : 'col-sm-12 col-md-12 mb-4'
                        "
                    >
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input
                                    type="text"
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"
                                    @keyup.enter="searchPrograms"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="searchPrograms"
                                        >
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle
                    v-bind:Text="$t('Shared.SearchResult')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <div class="row">
                    <div class="col-md-12">
                        <MdTable
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :editIconEvent="editProgram"
                            v-bind:VisibleEditIcon="hasPermissionEdit()"
                            :deleteIconEvent="removeProgram"
                            v-bind:VisibleDeleteIcon="hasPermissionDelete()"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction"
                        >
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import TestPanelSetupService from '@/services/testpanelsetup.service';
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import Permission from '@/common/Permission';
//import CPTService from '@/services/cpt.service';
import ProgramService from '@/services/programs.services';

export default {
    name: 'ProgramSetupListing',
    mixins: [DBFunctions, ShowMessage, Permission],

    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            parameter: {
                SearchCriteria: '',
                PageNumber: 0,
                PageSize: 0
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            fields: [
                {
                    key: 'code',
                    sortable: true,
                    label: this.$t('Shared.ProgramCode'),
                    class: 'text-left hidden'
                },
                {
                    key: 'name',
                    sortable: true,
                    label: this.$t('Shared.ProgramName'),
                    class: 'text-left'
                },
                {
                    key: 'description',
                    sortable: true,
                    label: this.$t('Shared.Description'),
                    class: 'text-left'
                },
                {
                    key: 'inPatient',
                    sortable: true,
                    label: this.$t('Shared.Inpatient')
                }
            ],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],
            isReadOnly: false,
            ShowMessageIsEmpty: false,
            Mode: ''
        };
    },

    methods: {
        addProgram() {
            this.Mode = 'Add';
            this.emitDataforFavorites();
            this.$emit('onUpdatedMenu', '');
            this.$router.push({ name: 'ProgramSetupAdd' });
        },

        async getProgramsAsync() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            try {
                const response = await ProgramService.getAll(this.parameter);

                if (response.status == '200' && response.data) {
                    this.items = response.data;
                    let headerString = response.headers['x-pagination'];

                    if (headerString) {
                        const header = JSON.parse(headerString);
                        this.totalRows = header.TotalCount;
                    }
                }

                this.showMessageIsEmpty = this.totalRows === 0 || this.items.length === 0;
            } catch (error) {
                this.showResponseErrorMessage(error);
            }
        },

        editProgram(row) {
            this.Mode = 'Edit';
            this.$router.push({
                name: 'ProgramSetupEdit',
                params: { id: row.code }
            });
        },

        removeProgram(row) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_vendor'
                })
                .then(value => {
                    if (value) {
                        ProgramService.delete(row.code)
                            .then(() => {
                                this.currentPage = 1;
                                this.searchPrograms();
                            })
                            .catch(error => {
                                this.showResponseErrorMessage(error);
                            });
                    }
                });
        },

        pageChanged(page) {
            this.currentPage = page;
            this.getProgramsAsync();
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.getProgramsAsync();
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        onRowSelected(items) {
            this.selected = items;
        },

        searchPrograms() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getProgramsAsync();
        }
    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.$nextTick(() => {
            this.getProgramsAsync();
        });
    }
};
</script>
